import { Card, CardHeader } from '../components/common/Card';

export function SettingsPage() {
  return (
    <div className="space-y-6 animate-in">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="text-gray-500 mt-1">Manage application settings</p>
      </div>
      <Card>
        <CardHeader title="Settings" />
        <div className="p-6 text-gray-500">
          Settings options will appear here.
        </div>
      </Card>
    </div>
  );
}
